import { PartnerHierarchyType } from 'clickNgo/entities/partner/configs'

export const checkIsBranchOrOnline = (hierarchyType: PartnerHierarchyType) =>
  hierarchyType === PartnerHierarchyType.BRANCH || hierarchyType === PartnerHierarchyType.ONLINE
